import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SimpleSelectOptionFormatter, useSimpleSelectOptionMapper } from '../components';
import { usePermissions } from '../components/Permissions';
import { getCountriesForPermissions } from '../helpers';
import { activeCountriesSelector, userPermissionsDataSelector } from '../state';
import { Country } from '../types';

const countryFormatter: SimpleSelectOptionFormatter = {
  type: 'translation',
  translationIdBase: 'operativeStructure.countries',
  sort: 'asc',
};

const useContrySelect = (allowedCountryCodes?: string[], propId: keyof Country = 'countryCode') => {
  const { resourcePermissions } = usePermissions();
  const activeCountries = useSelector(activeCountriesSelector);
  const permissions = useSelector(userPermissionsDataSelector);
  const countries = activeCountries.loaded && activeCountries.data ? activeCountries.data : [];

  const countriesForPermissions = useMemo(
    () => getCountriesForPermissions(resourcePermissions, permissions, countries),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [resourcePermissions, permissions, activeCountries]
  );

  const filteredCountries = allowedCountryCodes
    ? countriesForPermissions.filter(c => allowedCountryCodes.includes(c.countryCode))
    : countriesForPermissions;

  const disabled = !activeCountries.loaded || filteredCountries.length < 2;

  const options = useSimpleSelectOptionMapper(
    filteredCountries,
    propId,
    'countryCode',
    countryFormatter
  );
  return { options, disabled, loading: activeCountries.loading };
};

export default useContrySelect;
